import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import NavbarTop from "../components/NavbarTop";

const LS_KEY = "sidebarCollapsed";

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const v = localStorage.getItem(LS_KEY);
    return v === "1";
  });

  useEffect(() => {
    localStorage.setItem(LS_KEY, sidebarCollapsed ? "1" : "0");
  }, [sidebarCollapsed]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 992) setSidebarOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div className="app-shell">
      <NavbarTop
        onMenu={() => setSidebarOpen(true)}
        sidebarCollapsed={sidebarCollapsed}
        onToggleSidebarCollapse={() => setSidebarCollapsed((v) => !v)}
      />

      <div className="app-body d-flex">
        <div className="d-none d-lg-block tb-sidebar-rail flex-shrink-0">
          <Sidebar variant="desktop" collapsed={sidebarCollapsed} />
        </div>

        <Sidebar
          variant="mobile"
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />

        <main className="flex-grow-1 content-scroll p-2 p-md-3" style={{ minHeight: 0 }}>
          <div className="container-fluid px-1 px-md-2">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
